import {
  JbRefLogo
} from "./chunk.M6FCALA6.js";
import {
  __decorateClass
} from "./chunk.WHWUXFA2.js";

// src/components/jb-ref-header/jb-ref-header.ts
import { debounce, getEventElement, recenterNavItems, throttle } from "@bjb/bjb-web-components/dist/assets/scripts/JB";
import "@bjb/bjb-web-components/dist/components/icons/jb-burger-icon/jb-burger-icon";
import "@bjb/bjb-web-components/dist/components/icons/jb-e-service-icon/jb-e-service-icon";
import "@bjb/bjb-web-components/dist/components/icons/jb-search-icon/jb-search-icon";
import "@bjb/bjb-web-components/dist/components/jb-main-menu/jb-main-menu";
import { JbModal } from "@bjb/bjb-web-components/dist/components/jb-modal/jb-modal";
import { jbLinkClickedEventToJbTrackingEvent } from "@bjb/bjb-web-components/dist/mixins";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { html, LitElement, unsafeCSS } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { ifDefined } from "lit/directives/if-defined.js";

// src/components/jb-ref-header/jb-ref-header.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_ref_header_default = css`/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.profile-icon-button__label {
  font-family: var(--theme-font-regular-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-regular-weight, 400);
}

.profile-icon-button__label {
  font-size: var(--theme-typo-p-mini-highlight-desktop-fontsize, 0.813rem);
  font-weight: var(--theme-typo-p-mini-highlight-fontweight, var(--theme-font-regular-weight, 400));
  line-height: var(--theme-typo-p-mini-highlight-desktop-lineheight, 1.25rem);
}

.sr-only {
  block-size: 1px;
  border: 0;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
}

:host {
  display: block;
  position: relative;
}

nav {
  --rgb-primary: 255, 255, 255;
  color: rgb(var(--theme-color-royal-blue, 20 30 85));
  inline-size: 100%;
  min-block-size: 60px;
  position: absolute;
  text-align: start;
  transition: background-color 0.5s ease 0.2s, transform 0.4s ease-out;
  z-index: 100;
  /* Top left navigation */
  /* Icons */
  /* Market menu */
  /* Search menu */
  /* Overlay menu */
  /* E-Service overlay */
}
@media (min-width: 960px) {
  nav {
    min-block-size: 90px;
  }
}
@media (min-width: 1281px) {
  nav {
    min-block-size: 100px;
  }
}
nav a {
  color: #141e55;
}
nav .inner {
  --_notch-inset: calc(max(env(safe-area-inset-left), env(safe-area-inset-right)) + 5px);
  align-items: center;
  display: flex;
  padding: 18px max(20px, var(--_notch-inset)) 4px;
  transition: padding 0.5s;
}
@media (min-width: 960px) {
  nav .inner {
    padding: 28px max(26px, var(--_notch-inset)) 14px;
  }
}
@media (min-width: 1281px) {
  nav .inner {
    padding: 32px max(60px, var(--_notch-inset)) 16px;
  }
}
nav .language-zh {
  block-size: initial !important;
}
nav .top-left-navigation {
  align-items: center;
  display: flex;
  flex-basis: 40%;
  gap: var(--theme-spacing-m);
  z-index: 500;
}
nav .middle {
  display: flex;
  flex-basis: 20%;
  justify-content: center;
  padding-inline-end: var(--compensate-scrollbar, 0);
  z-index: 500;
}
nav .middle ::slotted(svg) {
  block-size: auto;
}
nav .right {
  align-items: center;
  display: flex;
  flex-basis: 40%;
  height: 36px;
  justify-content: flex-end;
  z-index: 500;
}
@media (min-width: 960px) {
  nav .right {
    gap: var(--theme-spacing-2xl);
  }
}
nav .mobile-search-wrap {
  display: none;
}
nav.no-animation {
  transition: none;
}
nav.no-animation:not(.overlay) {
  --svg-transition: none !important;
}
nav.no-animation .inner {
  transition: none;
}
nav.region .top-left-navigation .mobile-search-wrap {
  display: none;
}
nav.e-service .top-left-navigation .mobile-search-wrap, nav.search .top-left-navigation .mobile-search-wrap {
  display: none;
}
nav.is_hidden {
  transform: translateY(-100%);
}
nav.fixed {
  inset-block-start: 0;
  position: fixed;
}
@media (min-width: 1281px) {
  nav.fixed {
    min-block-size: 108px;
  }
}
nav.fixed:not(.transparent) {
  background-color: #141e55;
  color: #fff;
  --rgb-primary: 255, 255, 255;
  --logo-color: #fff;
}
nav.is_fixed {
  inset-block-start: 0 !important;
  position: fixed !important;
}
nav.transparent {
  background-color: transparent;
  color: rgb(var(--rgb-primary, 255, 255, 255));
}
nav.transparent.fixed:not(.is_fixed) {
  background-color: #141e55;
  --rgb-primary: 255, 255, 255;
  --logo-color: #fff;
}
nav.transparent + .placeholder {
  display: none;
}
nav.overlay {
  inline-size: 100%;
  position: fixed;
  transition: background-color 0.2s ease-in 0.1s;
  /* Icons */
}
@media (max-width: 599px) {
  nav.overlay .inner {
    padding: 18px 20px 8px;
  }
}
nav.overlay .inner a {
  color: #fff;
}
nav.overlay nav__navigation-service-item {
  display: none;
}
@media (min-width: 1281px) {
  nav.overlay nav__navigation-service-item {
    display: inline-block;
  }
  nav.overlay nav__navigation-service-item:first-of-type {
    display: none;
  }
}
nav.overlay .mobile-search-wrap {
  display: block;
}
@media (min-width: 960px) {
  nav.overlay .mobile-search-wrap {
    display: none;
  }
}
nav.overlay-fade-out {
  transition: background-color 0.5s !important;
}
nav.overlay-fade-out nav__logo svg {
  --svg-transition: fill 0.1s ease 0.4s;
}
nav.e-service nav__mobile-search-wrap {
  display: none;
}
nav:not(nav.transparent, nav.overlay, nav.sticky) {
  --rgb-primary: 20, 30, 85;
  --logo-color: #001489;
  --svg-transition: all 0.1s ease 0.5s;
}

jb-e-service-icon {
  --icon-display: none;
}
@media (min-width: 960px) {
  jb-e-service-icon {
    --icon-display: block;
  }
}
.overlay jb-e-service-icon {
  display: none;
}

jb-search-icon {
  --display: none;
  --fill-color: rgb(var(--rgb-primary, 255, 255, 255));
}
@media (min-width: 960px) {
  jb-search-icon {
    --display: block;
  }
}
.overlay jb-search-icon {
  --display: none;
}
.mobile-search-wrap jb-search-icon {
  --display: block;
}
@media (min-width: 960px) {
  .mobile-search-wrap jb-search-icon {
    --display: none;
  }
}

.overlay-fade-out jb-burger-icon {
  --bar-transition: transform 0.2s linear, border-color 0.1s ease 0.4s;
}

jb-burger-icon {
  padding-inline-end: var(--compensate-scrollbar, 0);
}

::slotted(jb-ref-logo) {
  block-size: 38px;
}
@media (min-width: 960px) {
  ::slotted(jb-ref-logo) {
    block-size: 48px;
  }
}
@media (min-width: 1281px) {
  ::slotted(jb-ref-logo) {
    block-size: 52px;
  }
}
.overlay-fade-out ::slotted(jb-ref-logo) {
  --svg-transition: fill 0.1s ease 0.4s;
}

::slotted(jb-service-navigation) {
  --display: none;
}
@media (min-width: 1281px) {
  ::slotted(jb-service-navigation) {
    --display: flex;
  }
}
.overlay ::slotted(jb-service-navigation) {
  --display: none;
}
@media (min-width: 1281px) {
  .overlay ::slotted(jb-service-navigation) {
    --display: flex;
  }
}
.search ::slotted(jb-service-navigation), .e-service ::slotted(jb-service-navigation), .region ::slotted(jb-service-navigation) {
  --display: none;
}

.overlay ::slotted(jb-region-indicator) {
  --display: none;
}
.region ::slotted(jb-region-indicator) {
  --before-height: 0;
  --after-right: 30px;
  --display: flex;
}

.profile-icon-button {
  align-items: center;
  color: inherit;
  cursor: pointer;
  display: none;
  gap: var(--theme-spacing-3xs);
  justify-content: center;
  text-decoration: none;
}
@media (min-width: 960px) {
  .profile-icon-button {
    display: flex;
  }
}
.overlay .profile-icon-button {
  display: none;
}
.profile-icon-button jb-ref-icon {
  height: 20px;
}
@media (min-width: 960px) {
  .profile-icon-button jb-ref-icon {
    height: 24px;
  }
}
@media print {
  .inner {
    justify-content: center;
  }
  nav .top-left-navigation,
  nav .right {
    display: none;
  }
}`;

// src/components/jb-ref-header/jb-ref-header.ts
var JbRefHeader = class extends LitElement {
  constructor() {
    super(...arguments);
    this.enableSearch = false;
    this.isTransparent = false;
    this._animateHiding = true;
    this._fixed = false;
    this._hidden = false;
    this._isAutohiding = true;
    this._overlayOpen = null;
    this._previousScrollposition = 0;
    this._scrollDistance = 0;
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener(
      "scroll",
      debounce(() => {
        this._scrollMainNavigation();
      }, 10)
    );
  }
  async updated(_changedProperties) {
    await this.updateComplete;
    if (this._logo) {
      this._logo.isWhite = !!(this.isTransparent || this._fixed || this._overlayOpen);
    }
    if (_changedProperties.has("_hidden") || _changedProperties.has("_fixed")) {
      this.dispatchEvent(
        new CustomEvent("jb-navigation:appearance-changed", {
          bubbles: true,
          composed: true,
          detail: {
            fixed: this._fixed,
            hidden: this._hidden
          }
        })
      );
    }
    if (this._overlayOpen) {
      disableBodyScroll(this, { allowTouchMove: () => true });
    } else {
      enableBodyScroll(this);
    }
    if (_changedProperties.has("_overlayOpen")) {
      if (this._overlayOpen) {
        this.style.zIndex = (this._getHighestOverlayZIndex() + 1).toString();
      } else {
        this.style.zIndex = "unset";
      }
      recenterNavItems();
      this._setBurgerIconState();
    }
  }
  async firstUpdated() {
    this._serviceNavigation = document.querySelector("jb-service-navigation") ?? void 0;
    this._logo = document.querySelector("jb-ref-logo") ?? void 0;
    this._placeholder = document.createElement("div");
    this._navigation?.after(this._placeholder);
    this._placeholder.classList.add("placeholder");
    this._placeholder.style.setProperty("height", this._navigation.clientHeight + "px");
    window.addEventListener(
      "resize",
      debounce(() => {
        this._placeholder.style.setProperty("height", this._navigation.clientHeight + "px");
      }, 10)
    );
    document.addEventListener("jb-link:clicked", (e) => {
      e.preventDefault();
      this._maybeOpenEServiceOverlay(e);
    });
    document.addEventListener("jb-modal:close", () => {
      if (this._overlayOpen) this._toggleMenuOverlay();
    });
    document.addEventListener(
      "burger-icon:clicked",
      throttle(() => {
        this._toggleMenuOverlay();
      }, 500)
    );
    this._menuComponent = await this._initMenu();
    window.setTimeout(() => {
      import("@bjb/bjb-web-components/dist/components/jb-e-service-overlay/jb-e-service-overlay").then();
      import("@bjb/bjb-web-components/dist/components/jb-region-select-overlay/jb-region-select-overlay").then();
      import("@bjb/bjb-web-components/dist/components/jb-search-overlay/jb-search-overlay").then();
    }, 50);
  }
  startAutoHide() {
    this._hidden = true;
    this._isAutohiding = true;
  }
  stopAutoHide() {
    this._hidden = false;
    this._isAutohiding = false;
  }
  _checkOpenEService() {
    return this._overlayOpen === "eService";
  }
  _checkOpenMenu() {
    return this._overlayOpen === "menu";
  }
  _checkOpenRegionSelect() {
    return this._overlayOpen === "regionSelect";
  }
  _checkOpenSearch() {
    return this._overlayOpen === "search";
  }
  async _findAnimatedElement(overlay, element, contentChildren) {
    if (element && overlay) {
      await customElements.whenDefined(element);
      const animatedElement = overlay.querySelector(element);
      if (contentChildren) {
        animatedElement.contentChildren = Array.from(animatedElement.shadowRoot.querySelectorAll(contentChildren));
      }
      return animatedElement;
    }
    return null;
  }
  _fireTrackingEvent(additionalEventDetails) {
    const eventDetails = {
      event: "ce_interaction",
      component_name: "header",
      event_version: "v2",
      interaction_type: "click"
    };
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: { ...eventDetails, ...additionalEventDetails },
        bubbles: true,
        composed: true
      })
    );
  }
  _getHighestOverlayZIndex() {
    const overlays = Array.from(document.querySelectorAll("jb-modal"));
    const overlaysIndex = [];
    overlays.map((overlay) => overlaysIndex.push(overlay.zIndex()));
    return Math.max(...overlaysIndex);
  }
  async _initMenu() {
    const { JbMainMenu } = await import("@bjb/bjb-web-components/dist/components/jb-main-menu/jb-main-menu");
    return new JbMainMenu().init({ props: { ...this.menu, preInitChildren: true, preventZOrder: true } });
  }
  _initOverlay(childNode) {
    childNode.setAttribute("slot", "content");
    const overlay = new JbModal().init({
      // Render the RE logo in the overlay (recoloured white for the blue background).
      props: {
        color: "blue",
        hasLogo: true,
        svgLogo: JbRefLogo.logoSvg.replace(/#001489/g, "#ffffff"),
        newAnimation: true,
        // Return focus to the burger when the overlay closes (the menu's entry point).
        returnFocusTo: this._burgerIcon
      },
      childNodes: [childNode]
    });
    return overlay;
  }
  async _initRegionOverlay() {
    const { JbRefLanguageOverlay } = await import("../components/jb-ref-language-overlay/jb-ref-language-overlay.js");
    return new JbRefLanguageOverlay().init({ props: { ...this.regionSelectOverlay } });
  }
  async _initSearchOverlay() {
    const { JbSearchOverlay } = await import("@bjb/bjb-web-components/dist/components/jb-search-overlay/jb-search-overlay");
    return new JbSearchOverlay().init({ props: { ...this.searchOverlay } });
  }
  _maybeOpenEServiceOverlay(customEvent) {
    if (customEvent.detail.action === "e-services") {
      customEvent.stopPropagation();
      customEvent.detail.clickEvent.preventDefault();
      customEvent.detail.clickEvent.stopPropagation();
      this._openEServiceOverlay().then();
    }
  }
  async _openEServiceOverlay() {
    if (this.eServiceOverlay === void 0) {
      return;
    }
    const { JbEServiceOverlay } = await import("@bjb/bjb-web-components/dist/components/jb-e-service-overlay/jb-e-service-overlay");
    const eServiceOverlay = new JbEServiceOverlay().init({ props: { ...this.eServiceOverlay } });
    if (this._checkOpenMenu()) {
      this._overlayFront = this._initOverlay(eServiceOverlay);
      this._overlayFront.stack();
      this._findAnimatedElement(this._overlayFront, "jb-e-service-overlay", "div.eservices").then(async (element) => {
        this._overlayOpen = "eService";
        this._serviceNavigation.hideItems = "all";
        await element?.reveal?.();
      });
    } else {
      this._overlayBack = this._initOverlay(eServiceOverlay);
      this._overlayBack.stack();
      this._findAnimatedElement(this._overlayBack, "jb-e-service-overlay", "div.eservices").then(async (element) => {
        this._overlayOpen = "eService";
        await element?.reveal?.();
      });
    }
  }
  async _openSearchOverlay() {
    if (this._checkOpenMenu()) {
      this._overlayFront = this._initOverlay(await this._initSearchOverlay());
      this._overlayFront.stack();
      this._findAnimatedElement(this._overlayFront, "jb-search-overlay", "jb-search-input").then(async (element) => {
        this._overlayOpen = "search";
        this._serviceNavigation.hideItems = void 0;
        await element?.reveal?.();
      });
    } else {
      this._overlayBack = this._initOverlay(await this._initSearchOverlay());
      this._overlayBack.stack();
      this._findAnimatedElement(this._overlayBack, "jb-search-overlay", "jb-search-input").then(async (element) => {
        this._overlayOpen = "search";
        await element?.reveal?.();
      });
    }
  }
  _scrollMainNavigation() {
    if (this._overlayOpen || !this._isAutohiding) {
      return;
    }
    const scrollUpToggleDistance = 100;
    const minimumOffsetYtoShow = 500;
    const minimumOffsetYtoAnimate = 300;
    const { pageYOffset } = window;
    const scrollDirection = pageYOffset <= this._previousScrollposition ? "up" : "down";
    if (pageYOffset > this._navigation.offsetHeight) {
      this._fixed = true;
      this._hidden = true;
    } else {
      this._fixed = false;
      this._hidden = false;
    }
    if (scrollDirection === "up") {
      this._scrollDistance += window.scrollY - this._previousScrollposition;
      if (pageYOffset > minimumOffsetYtoShow && Math.abs(this._scrollDistance) > scrollUpToggleDistance) {
        this._hidden = false;
      }
      this._animateHiding = pageYOffset <= minimumOffsetYtoAnimate;
    } else {
      if (pageYOffset > this._navigation.offsetHeight) {
        this._hidden = true;
      }
      this._scrollDistance = 0;
    }
    this._previousScrollposition = pageYOffset <= 0 ? 0 : pageYOffset;
  }
  _setBurgerIconState() {
    this._burgerIcon.isOpen = !!this._overlayOpen;
  }
  async _toggleMenuOverlay() {
    if (this._overlayFront) {
      if (this._overlayOpen === "search") {
        await this._findAnimatedElement(this._overlayFront, "jb-search-overlay", "jb-search-input").then(
          async (element) => {
            await element?.hide?.();
          }
        );
      }
      if (this._overlayOpen === "eService") {
        await this._findAnimatedElement(this._overlayFront, "jb-e-service-overlay", "div.eservices").then(
          async (element) => {
            await element?.hide?.();
          }
        );
      }
      this._overlayFront.unstack();
      this._overlayFront = void 0;
      this._serviceNavigation.hideItems = "first";
      this._overlayOpen = "menu";
      return;
    }
    if (!this._overlayOpen) {
      this._overlayBack = this._initOverlay(await this._menuComponent);
      this._overlayBack.stack("jb-ref-header");
      await this._findAnimatedElement(this._overlayBack, "jb-main-menu", "").then(async (element) => {
        this._overlayOpen = "menu";
        this._serviceNavigation.hideItems = "first";
        element.contentDuration = 300;
        element.wrapperDuration = 350;
        await element?.reveal?.();
      });
    } else {
      if (this._overlayOpen === "search") {
        await this._findAnimatedElement(this._overlayBack, "jb-search-overlay", "jb-search-input").then(
          async (element) => {
            await element?.hide?.();
          }
        );
      }
      if (this._overlayOpen === "eService") {
        await this._findAnimatedElement(this._overlayBack, "jb-e-service-overlay", "div.eservices").then(
          async (element) => {
            await element?.hide?.();
          }
        );
      }
      if (this._overlayOpen === "menu") {
        await this._findAnimatedElement(this._overlayBack, "jb-main-menu", "").then(async (element) => {
          await element?.hide?.();
        });
      }
      if (this._overlayOpen === "regionSelect") {
        await this._findAnimatedElement(
          this._overlayBack,
          "jb-ref-language-overlay",
          ".region-select-overlay__wrap"
        ).then(async (element) => {
          await element?.hide?.();
        });
      }
      this._overlayBack.unstack();
      this._overlayOpen = null;
      this._serviceNavigation.hideItems = "all-except-first";
    }
  }
  async _toggleRegionOverlay(e) {
    if (!this._overlayOpen) {
      this._trackEventsRegionIndicator(e);
      this._overlayBack = this._initOverlay(await this._initRegionOverlay());
      this._overlayBack.stack();
      this._findAnimatedElement(this._overlayBack, "jb-ref-language-overlay", ".region-select-overlay__wrap").then(
        async (element) => {
          this._overlayOpen = "regionSelect";
          this._serviceNavigation.hideItems = "all";
          await element?.reveal?.();
        }
      );
    } else {
      this._findAnimatedElement(this._overlayBack, "jb-ref-language-overlay", ".region-select-overlay__wrap").then(
        async (element) => {
          await element?.hide?.();
          this._overlayBack.unstack();
          this._serviceNavigation.hideItems = "all-except-first";
          this._overlayOpen = null;
        }
      );
    }
  }
  _trackEventsRegionIndicator(e) {
    if (getEventElement(e, "JB-REGION-INDICATOR")) {
      const additionalEventDetails = {
        interaction_effect: "open",
        interaction_element: "location-selector",
        interaction_result: "overlay",
        interaction_text: "location-selector"
      };
      this._fireTrackingEvent(additionalEventDetails);
    }
  }
  _trackIconClick(event) {
    if (getEventElement(event, "JB-REF-LOGO")) {
      const additionalEventDetails = {
        interaction_effect: "navigation",
        interaction_element: "logo",
        interaction_result: getEventElement(event, "JB-REF-LOGO")?.href,
        interaction_text: "logo"
      };
      this._fireTrackingEvent(additionalEventDetails);
      return;
    }
    if (getEventElement(event, "JB-E-SERVICE-ICON")) {
      const additionalEventDetails = {
        interaction_effect: "open",
        interaction_element: "e-services",
        interaction_result: "overlay",
        interaction_text: "e-services"
      };
      this._fireTrackingEvent(additionalEventDetails);
      return;
    }
    if (getEventElement(event, "JB-SEARCH-ICON")) {
      if (this._overlayOpen) {
        const additionalEventDetails2 = {
          interaction_effect: "open",
          interaction_element: "search",
          interaction_result: "overlay",
          interaction_text: "hamburger__search"
        };
        this._fireTrackingEvent(additionalEventDetails2);
        return;
      }
      const additionalEventDetails = {
        interaction_effect: "open",
        interaction_element: "search",
        interaction_result: "overlay",
        interaction_text: "search"
      };
      this._fireTrackingEvent(additionalEventDetails);
      return;
    }
    if (getEventElement(event, "JB-BURGER-ICON") && !this._overlayOpen) {
      const additionalEventDetails = {
        interaction_effect: "open",
        interaction_element: "hamburger",
        interaction_result: "overlay",
        interaction_text: "hamburger"
      };
      this._fireTrackingEvent(additionalEventDetails);
    }
  }
  _trackLinkClick(e) {
    e.stopPropagation();
    if (e.detail.clickEvent) {
      e.detail.clickEvent.stopPropagation();
    }
    const eventEl = getEventElement(e, "JB-SERVICE-NAVIGATION-ITEM");
    if (eventEl) {
      if (eventEl.link?.data?.action === "e-services") {
        const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
          component_name: "header",
          interaction_effect: "open",
          interaction_element: "e-services",
          interaction_result: "overlay",
          interaction_text: "hamburger__e-services"
        });
        if (jbTrackingEvent) {
          this.dispatchEvent(jbTrackingEvent);
        }
        return;
      }
      const text = eventEl.trackingLabel.toLowerCase();
      const additionalEventDetails = {
        interaction_effect: "navigation",
        interaction_element: text.replace(/\s+/g, "-").toLowerCase(),
        interaction_result: eventEl.link?.href,
        interaction_text: text.replace(/\s+/g, "-").toLowerCase()
      };
      this._fireTrackingEvent(additionalEventDetails);
    }
  }
  render() {
    return html`
      <nav
        role="navigation"
        aria-expanded="${this._overlayOpen ? "true" : "false"}"
        aria-label="${this.ariaLabelNavigation ?? "Navigation"}"
        class=${classMap({
      transparent: !!this.isTransparent,
      menu: !!this._overlayOpen,
      overlay: !!this._overlayOpen,
      "e-service": this._checkOpenEService(),
      search: this._checkOpenSearch(),
      region: this._checkOpenRegionSelect(),
      "no-animation": this._animateHiding,
      is_hidden: this._hidden,
      fixed: this._fixed,
      is_fixed: !this._isAutohiding
    })}
        @e-service-icon:clicked=${this._openEServiceOverlay}
        @region-indicator:clicked=${this._toggleRegionOverlay}
        @search-icon:clicked=${this._openSearchOverlay}
        @jb-link:clicked=${this._trackLinkClick}
      >
        <div class="inner">
          <div class="top-left-navigation">
            <div class="${classMap({ hidden: this._checkOpenSearch(), "mobile-search-wrap": true })}">
              ${this.enableSearch ? html`<jb-search-icon
                    aria-label="${this.ariaLabelSearch ?? "Search"}"
                    role="button"
                    @click=${this._trackIconClick}
                  ></jb-search-icon>` : ""}
            </div>
            <slot name="left"></slot>
          </div>
          <div
            class="middle"
            part="logo"
          >
            <slot
              name="middle"
              @click=${this._trackIconClick}
            ></slot>
          </div>
          <div class="right">
            <slot name="right"></slot>
            ${this.profileIcon ? html`<a
                  class="profile-icon-button"
                  href="${ifDefined(this.profileIcon.link?.href)}"
                  target="${ifDefined(this.profileIcon.link?.target)}"
                  title="${ifDefined(this.profileIcon.tooltip)}"
                >
                  <jb-ref-icon name="${ifDefined(this.profileIcon.icon?.name)}"></jb-ref-icon>
                  ${this.profileIcon.label ? html`<span class="profile-icon-button__label">${this.profileIcon.label}</span>` : ""}
                </a>` : ""}
            ${this.eServiceOverlay && html`<jb-e-service-icon
              aria-label="${this.ariaLabelEServices ?? "E-Services"}"
              role="button"
              @click=${this._trackIconClick}
            ></jb-e-service-icon>`}
            ${this.enableSearch ? html` <jb-search-icon
                  aria-label="${this.ariaLabelSearch ?? "Search"}"
                  role="button"
                  @click=${this._trackIconClick}
                ></jb-search-icon>` : ""}
            <jb-burger-icon
              aria-label="${this.ariaLabelMenu ?? "Menu"}"
              role="button"
              tabindex="0"
              @click=${this._trackIconClick}
            ></jb-burger-icon>
          </div>
        </div>
      </nav>
    `;
  }
};
JbRefHeader.styles = unsafeCSS(jb_ref_header_default);
__decorateClass([
  property()
], JbRefHeader.prototype, "ariaLabelEServices", 2);
__decorateClass([
  property()
], JbRefHeader.prototype, "ariaLabelMenu", 2);
__decorateClass([
  property()
], JbRefHeader.prototype, "ariaLabelNavigation", 2);
__decorateClass([
  property()
], JbRefHeader.prototype, "ariaLabelSearch", 2);
__decorateClass([
  property({ type: Boolean })
], JbRefHeader.prototype, "enableSearch", 2);
__decorateClass([
  property({ type: Object })
], JbRefHeader.prototype, "eServiceOverlay", 2);
__decorateClass([
  property({ type: Boolean })
], JbRefHeader.prototype, "isTransparent", 2);
__decorateClass([
  property({ type: Object })
], JbRefHeader.prototype, "menu", 2);
__decorateClass([
  property({ type: Object })
], JbRefHeader.prototype, "profileIcon", 2);
__decorateClass([
  property({ type: Object })
], JbRefHeader.prototype, "regionSelectOverlay", 2);
__decorateClass([
  property({ type: Object })
], JbRefHeader.prototype, "searchOverlay", 2);
__decorateClass([
  state()
], JbRefHeader.prototype, "_animateHiding", 2);
__decorateClass([
  query("jb-burger-icon")
], JbRefHeader.prototype, "_burgerIcon", 2);
__decorateClass([
  state()
], JbRefHeader.prototype, "_fixed", 2);
__decorateClass([
  state()
], JbRefHeader.prototype, "_hidden", 2);
__decorateClass([
  state()
], JbRefHeader.prototype, "_isAutohiding", 2);
__decorateClass([
  query("nav")
], JbRefHeader.prototype, "_navigation", 2);
__decorateClass([
  state()
], JbRefHeader.prototype, "_overlayOpen", 2);
JbRefHeader = __decorateClass([
  customElement("jb-ref-header")
], JbRefHeader);

export {
  JbRefHeader
};
